import { render, staticRenderFns } from "./DeleteProjectUser.vue?vue&type=template&id=623e4069&"
import script from "./DeleteProjectUser.vue?vue&type=script&lang=js&"
export * from "./DeleteProjectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports